import { useEffect } from "react";
import { diag } from "@/lib/diag";

/**
 * Shown for a screen marked disabled in its config, instead of a black panel
 * with nothing configured. A new location rolling out screens one at a time
 * needs the unused ones to look deliberate, not broken.
 */
export function ComingSoon({ screenId }: { screenId: string }) {
  useEffect(() => {
    diag("disabled_screen");
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1.5rem",
        background: "#0a0a0a",
        color: "#e5e5e5",
        fontFamily: "system-ui, sans-serif",
        textAlign: "center",
      }}
    >
      <div style={{ fontSize: "clamp(2rem, 5vw, 4rem)", fontWeight: 700, letterSpacing: "0.02em" }}>Coming Soon</div>
      <div style={{ fontSize: "clamp(1rem, 2vw, 1.5rem)", opacity: 0.5 }}>Screen {screenId}</div>
    </div>
  );
}
